

import {
  FETCH_MUNICIPALITIES_REQUEST,
  FETCH_MUNICIPALITIES_SUCCESS,
  FETCH_MUNICIPALITIES_FAILURE,
  CREATE_MUNICIPALITY_SUCCESS,
  CREATE_MUNICIPALITY_FAILURE,
  UPDATE_MUNICIPALITY_REQUEST,
  UPDATE_MUNICIPALITY_SUCCESS,
  UPDATE_MUNICIPALITY_FAILURE,
} from "../actions/municipalitiesActions";

const initialState = {
  municipalities: [],
  loading: false,
  error: null,

  // Create municipality status
  createStatus: null,
  createMessage: null,

  // Update municipality status
  updateStatus: null,
  updateMessage: null,
};

const municipalitiesReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_MUNICIPALITIES_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_MUNICIPALITIES_SUCCESS:
      return {
        ...state,
        loading: false,
        municipalities: action.payload,
      };

    case FETCH_MUNICIPALITIES_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case CREATE_MUNICIPALITY_SUCCESS:
      return {
        ...state,
        createStatus: "success",
        createMessage: "Municipality created successfully!",
      };

    case CREATE_MUNICIPALITY_FAILURE:
      return {
        ...state,
        createStatus: "failure",
        createMessage: action.payload,
      };

    case UPDATE_MUNICIPALITY_REQUEST:
      return {
        ...state,
        updateStatus: "loading",
        updateMessage: null,
      };

    case UPDATE_MUNICIPALITY_SUCCESS:
      return {
        ...state,
        updateStatus: "success",
        updateMessage: "Municipality updated successfully!",
      };

    case UPDATE_MUNICIPALITY_FAILURE:
      return {
        ...state,
        updateStatus: "failure",
        updateMessage: action.payload,
      };

    default:
      return state;
  }
};

export default municipalitiesReducer;
